export default __webpack_public_path__ + "static/media/319.ff89b6db.png";